var abi = require('ethereumjs-abi');

var keccak256 = require('js-sha3').keccak256;

var Interface = require('ethers').utils.Interface;

var ensure = require('./ensureTypes');

var coreABI = require('../abi/AdExCore');

var coreInterface = new Interface(coreABI);

function Transaction(args) {
  this.identityContract = ensure.Address(args.identityContract);
  this.nonce = ensure.Uint256(args.nonce);
  this.feeTokenAddr = ensure.Address(args.feeTokenAddr);
  this.feeAmount = ensure.Uint256(args.feeAmount);
  this.to = ensure.Address(args.to);
  this.value = ensure.Uint256(args.value);
  this.data = ensure.Bytes(args.data);
  Object.freeze(this);
  return this;
}

Transaction.prototype.hash = function () {
  var buf = abi.rawEncode(['address', 'uint256', 'address', 'uint256', 'address', 'uint256', 'bytes'], [this.identityContract, this.nonce, this.feeTokenAddr, this.feeAmount, this.to, this.value, this.data]);
  return Buffer.from(keccak256.arrayBuffer(buf));
};

Transaction.prototype.hashHex = function () {
  return "0x".concat(this.hash().toString('hex'));
};

Transaction.prototype.toSolidityTuple = function () {
  // etherjs doesn't seem to want BN.js instances; hex is the lowest common denominator for web3/ethers
  return [this.identityContract, "0x".concat(this.nonce.toString(16)), this.feeTokenAddr, "0x".concat(this.feeAmount.toString(16)), this.to, "0x".concat(this.value.toString(16)), "0x".concat(this.data.toString('hex'))];
};

function RoutineAuthorization(args) {
  this.relayer = ensure.Address(args.relayer);
  this.outpace = ensure.Address(args.outpace);
  this.validUntil = ensure.Uint256(args.validUntil);
  this.feeTokenAddr = ensure.Address(args.feeTokenAddr);
  this.weeklyFeeAmount = ensure.Uint256(args.weeklyFeeAmount);
  Object.freeze(this);
  return this;
}

RoutineAuthorization.prototype.hash = function () {
  var buf = abi.rawEncode(['address', 'address', 'uint256', 'address', 'uint256'], [this.relayer, this.outpace, this.validUntil, this.feeTokenAddr, this.weeklyFeeAmount]);
  return Buffer.from(keccak256.arrayBuffer(buf));
};

RoutineAuthorization.prototype.hashHex = function () {
  return "0x".concat(this.hash().toString('hex'));
};

RoutineAuthorization.prototype.toSolidityTuple = function () {
  // etherjs doesn't seem to want BN.js instances; hex is the lowest common denominator for web3/ethers
  return [this.relayer, this.outpace, "0x".concat(this.validUntil.toString(16)), this.feeTokenAddr, "0x".concat(this.weeklyFeeAmount.toString(16))];
};

var RoutineOps = {
  channelWithdraw: function channelWithdraw(args) {
    var data = "0x".concat(coreInterface.functions.channelWithdraw.encode(args).slice(10));
    return [0, data];
  },
  channelWithdrawExpired: function channelWithdrawExpired(args) {
    var data = "0x".concat(coreInterface.functions.channelWithdrawExpired.encode(args).slice(10));
    return [1, data];
  }
};
module.exports = {
  Transaction: Transaction,
  RoutineAuthorization: RoutineAuthorization,
  RoutineOps: RoutineOps
};